import { render, staticRenderFns } from "./CryptoWithdrawFormOtp.vue?vue&type=template&id=d5321c82"
import script from "./CryptoWithdrawFormOtp.vue?vue&type=script&lang=js"
export * from "./CryptoWithdrawFormOtp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports